module.exports = __webpack_public_path__ + "img/transfer5.05553ac3.jpeg";